import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LegalFooter from "../components/LegalFooter";
import usePlayerManifest from "../hooks/usePlayerManifest";
import PasswordInput from "../components/PasswordInput";
import storage from '../nativeStorage';

export default function PlayerLogin() {
  usePlayerManifest();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async () => {
    setError("");
    if (!form.email || !form.password) return setError("All fields are required");
    setLoading(true);
    try {
      const res = await fetch("/api/player/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) return setError(data.error || "Login failed");
      storage.setItem("player_token", data.token);
      storage.setItem("player_name", data.player.name || data.player.email);
      navigate("/player/dashboard");
    } catch(e) { setError("Network error"); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f0fdf4", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
      <div style={{ background: "white", borderRadius: "12px", padding: "32px", width: "100%", maxWidth: "400px", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <div style={{ width: "64px", height: "64px", background: "#14532d", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px", fontSize: "28px" }}>⛳</div>
          <h1 style={{ fontSize: "20px", fontWeight: "800", color: "#14532d", margin: 0 }}>Golf Society Manager</h1>
          <p style={{ fontSize: "13px", color: "#6b7280", marginTop: "4px" }}>Player Portal</p>
        </div>

        {error && <div style={{ background: "#fee2e2", color: "#b91c1c", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "16px" }}>{error}</div>}

        <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
          <div>
            <label style={{ fontSize: "12px", fontWeight: "600", color: "#374151", display: "block", marginBottom: "4px" }}>Email Address</label>
            <input name="email" type="email" value={form.email} onChange={handle} placeholder="your@email.com"
              style={{ width: "100%", border: "1px solid #d1d5db", borderRadius: "8px", padding: "10px 12px", fontSize: "14px" }} />
          </div>
          <div>
            <label style={{ fontSize: "12px", fontWeight: "600", color: "#374151", display: "block", marginBottom: "4px" }}>Password</label>
            <PasswordInput name="password" value={form.password} onChange={handle} placeholder="Your password"
              style={{ width: "100%", border: "1px solid #d1d5db", borderRadius: "8px", padding: "10px 12px", fontSize: "14px" }} />
          </div>

          <button onClick={submit} disabled={loading}
            style={{ background: "#14532d", color: "white", border: "none", borderRadius: "8px", padding: "12px", fontSize: "14px", fontWeight: "700", cursor: "pointer", opacity: loading ? 0.7 : 1 }}>
            {loading ? "Logging in..." : "Player Login"}
          </button>

          <button onClick={() => navigate("/player/register")}
            style={{ background: "none", border: "1px solid #d1d5db", borderRadius: "8px", padding: "10px", fontSize: "13px", color: "#6b7280", cursor: "pointer" }}>
            New player? Register here
          </button>

          <button onClick={() => navigate("/login")}
            style={{ background: "none", border: "none", fontSize: "12px", color: "#9ca3af", cursor: "pointer" }}>
            Society Admin Login →
          </button>
        </div>
        <div style={{ marginTop: "20px" }}>
          <LegalFooter />
        </div>
      </div>
    </div>
  );
}
